import {useContext, useEffect} from 'react';
import axios from 'axios';
import TagManager from 'react-gtm-module';
import {RootContext} from '../context/root-context';
import i18n from '../i18n';

// helpers
import gameStates from '../helpers/gameState';
import {trackPageView} from '../helpers/gaHelper';
import {useLocation} from 'react-router-dom';

const useGame = () => {
  const [state, setState] = useContext(RootContext);
  const {REACT_APP_LANGUAGE, REACT_APP_BACKEND, REACT_APP_GTM_CODE} = process.env;

  const location = useLocation();
  const isRussian = location.search && location.search.toLowerCase().includes('lang=ru');
  const language = (isRussian && (REACT_APP_LANGUAGE === 'et' || REACT_APP_LANGUAGE === 'lv')) ? 'ru' : REACT_APP_LANGUAGE;


  const saveScore = async (score) => {

    const formData = new FormData();
    formData.append('score', score);
    formData.append('domain', REACT_APP_LANGUAGE);

    try {

      //const base = window.location.href.split('?')[0];
      // const base = window.location.href;
      // Followin line is fix for agency's crap code: const fullUrl = `${base}backend/?score=${score}&domain=${REACT_APP_LANGUAGE}`;
      const fullUrl = `${REACT_APP_BACKEND}?score=${score}&domain=${REACT_APP_LANGUAGE}`;
      // console.log(fullUrl);
      const response = await axios.get(fullUrl);

      if (response.data && response.data.players) {
        setState((currentState) => ({
          ...currentState,
          otherPlayers: response.data.players,
        }));
      }

    } catch (error) {
      console.log(error);
    }

  };

  /**
   * Go to next question
   */
  const nextQuestion = async (evt) => {
    // get current state
    let newGameState;
    switch (state.gameState) {
      case gameStates.INTRO:
        newGameState = gameStates.QUESTION_1;
        break;
      case gameStates.QUESTION_1:
        newGameState = gameStates.QUESTION_2;
        break;
      case gameStates.QUESTION_2:
        newGameState = gameStates.QUESTION_3;
        break;
      case gameStates.QUESTION_3:
        newGameState = gameStates.QUESTION_4;
        break;
      case gameStates.QUESTION_4:
        newGameState = gameStates.QUESTION_5;
        break;
      case gameStates.QUESTION_5:
        newGameState = gameStates.QUESTION_6;
        break;
      case gameStates.QUESTION_6:
        newGameState = gameStates.QUESTION_7;
        break;
      case gameStates.QUESTION_7:
        newGameState = gameStates.QUESTION_8;
        break;
      case gameStates.QUESTION_8:
        newGameState = gameStates.QUESTION_9;
        break;
      case gameStates.QUESTION_9:
        newGameState = gameStates.QUESTION_10;
        break;
      case gameStates.QUESTION_10:
        newGameState = gameStates.ENDED;
        break;
      default:
        newGameState = gameStates.INTRO;
    }

    // update the state
    setState((currentState) => ({
      ...currentState,
      gameState: newGameState,
      randomNumber: Math.floor(Math.random() * (12 - 1 + 1) + 1),
    }));
  };

  const addScore = (score, saveToBackend = false) => {
    const totalScore = state.totalScore + score;

    setState((currentState) => ({
      ...currentState,
      totalScore,
    }));

    if (saveToBackend) {
      saveScore(totalScore);
    }
  };

  const setLanguage = async (language) => {
    await i18n.changeLanguage(language);

    setState((currentState) => ({
      ...currentState,
      language,
      hasChanged: true,
    }));
  };

  useEffect(() => {
    if (!state.hasChanged) {
      setLanguage(language);
    }
  }, [language]);

  const toggleAudioState = (evt, button) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {      
      setState((currentState) => ({
        ...currentState,
        isPlayingBackgroundMusic: !currentState.isPlayingBackgroundMusic
      }));

      setTimeout(() => {
        if (button === 'sound-top-intro') {
          document.getElementById('sound-top-intro').focus();        

        } else {
          document.getElementById('sound-top').focus();        
        }
      }, 100);
    }
  };

  const navigateToAccessiblePageVersion = (evt) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {      
      let redirectUrl = '';

        if(REACT_APP_LANGUAGE === 'et' && language === 'et'){
          redirectUrl = 'https://www.seb.ee/sites/default/files/calc/Cybersecurity-accessible/browser/index.html';
        }
        if(REACT_APP_LANGUAGE === 'et' && language === 'ru'){
          redirectUrl = "https://www.seb.ee/sites/default/files/calc/Cybersecurity-accessible/browser/index.html";
        }
        if(REACT_APP_LANGUAGE === 'lt' && language === 'lt'){
          redirectUrl = 'https://www.seb.lt/sites/default/files/calc/Cybersecurity-accessible/browser/index.html';
        }
        if(REACT_APP_LANGUAGE === 'lv' && language === 'lv'){
          redirectUrl = "https://www.seb.lv/sites/default/files/calc/Cybersecurity-accessible/browser/index.html";
        }
        if(REACT_APP_LANGUAGE === 'lv' && language === 'ru'){
          redirectUrl = "https://www.seb.lv/sites/default/files/calc/Cybersecurity-accessible/browser/index.html";
      }
      
      window.location.href = redirectUrl;
    }
  };

  // is listening to audio in question 9
  const setIsListeningToAudio = (isListeningToAudio) => {
    setState((currentState) => ({
      ...currentState,
      isListeningToAudio,
    }));
  };

  const resetGame = () => {
    setState((currentState) => ({
      ...currentState,
      gameState: gameStates.QUESTION_1,
      totalScore: 0,
      otherPlayers: 0,
      randomNumber: Math.floor(Math.random() * (12 - 1 + 1) + 1),
    }));
  };

  const setTrackUser = (value) => {
    setState((currentState) => ({
      ...currentState,
      trackUser: value
    }));
  };

  // analytics stuff
  const initializeGTM = () => {
    if (!state.gtmInitialized && typeof REACT_APP_GTM_CODE !== 'undefined' && state.trackUser) {
      // initialize GTM
      // console.log('init gtm');

      const tagManagerArgs = {
        gtmId: REACT_APP_GTM_CODE,
        dataLayerName: 'Form'
      };

      TagManager.initialize(tagManagerArgs);

      setState((currentState) => ({
        ...currentState,
        gtmInitialized: true,
      }));
    }
  };

  const trackGTMEvent = (value) => {
    // console.log('trying to track event ', value);

    // trackPageView(`page/${value}`)


    if (state.gtmInitialized) {
      // console.log('tracking event ', value);

      const tagManagerArgs = {
        dataLayer: {
          step: value,
          event: 'Form'
        },
        dataLayerName: 'Form'
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const showSoundLayer = (evt) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {
      window.scrollBy(0, 700);
    }
  }

  return {
    gameState: state.gameState,
    language: state.language,
    totalScore: state.totalScore,
    otherPlayers: state.otherPlayers,
    isPlayingBackgroundMusic: state.isPlayingBackgroundMusic,
    isListeningToAudio: state.isListeningToAudio,
    initializeGTM,
    setIsListeningToAudio,
    toggleAudioState,
    navigateToAccessiblePageVersion,
    nextQuestion,
    setLanguage,
    addScore,
    resetGame,
    setTrackUser,
    trackGTMEvent,
    trackUser: state.trackUser,
    randomNumber: state.randomNumber,
    showSoundLayer,
  };
};

export default useGame;
